import React, { FC, useState } from "react";
import classNames from "classnames";
import { TwoColumnsList } from "@app/components/base-page/models";
import {
  BlockHeader,
  HeaderLevel,
} from "../../../../../common/block-header/BlockHeader";

type Props = {
  lists: TwoColumnsList[];
};

export const Lists: FC<Props> = ({ lists }) => {
  const [active, setActive] = useState<string>("");

  return (
    <>
      {lists?.map((list, index) => (
        <div key={list._uid}>
          <div
            className={classNames(
              "collapse collapse-arrow",
              "group rounded-none border-solid border-divider py-1 text-regular",
              "lg:py-2",
              "xl:py-3",
              {
                "border-t": index !== 0,
                "collapse-open": active === list._uid,
              },
            )}
          >
            <div
              className={classNames(
                "collapse-title !cursor-pointer",
                "pl-0 text-primary-content",
              )}
              onClick={() =>
                setActive((prev) => (prev === list._uid ? "" : list._uid))
              }
            >
              <BlockHeader
                richText={list.title}
                headerLevel={HeaderLevel.H5}
                className={classNames(
                  "text-extra-small",
                  "lg:text-regular",
                  "xl:text-medium",
                )}
              />
            </div>
            <div
              className={classNames(
                "collapse-content",
                "px-0 text-base-400",
                "[&>p]:mb-2.5 last:[&>p]:mb-0 [&>p]:lg:mb-5",
                "group-has-[:checked]:pb-5",
                "xl:group-has-[:checked]:pb-7",
              )}
            >
              {list.items?.map((item, index) => (
                <div
                  key={item._uid}
                  className={classNames(
                    "flex flex-col py-5",
                    "border-solid border-divider",
                    "md:flex-row md:justify-between md:gap-8",
                    "lg:py-6",
                    "xl:py-7",
                    { "border-b": index !== list.items.length - 1 },
                  )}
                >
                  <div
                    className={classNames(
                      "text-extra-small",
                      "md:grow",
                      "lg:text-regular",
                      "xl:w-[64%] xl:flex-none",
                    )}
                  >
                    {item.name}
                  </div>
                  <div
                    className={classNames(
                      "text-extra-small text-primary-content",
                      "md:w-1/3 md:text-end",
                      "lg:text-regular",
                      "xl:w-[32%] xl:flex-none xl:text-start",
                    )}
                  >
                    {item.value}
                  </div>
                </div>
              ))}
              {list.footnote ? (
                <div
                  className={classNames(
                    "py-5 text-extra-small text-base-400",
                    "lg:py-6",
                    "xl:py-7",
                  )}
                >
                  {list.footnote}
                </div>
              ) : null}
            </div>
          </div>
        </div>
      ))}
    </>
  );
};
